import { Component, OnInit } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';
import { ValidateService } from '../services/validate.service';
import { CalculatorService } from '../services/calculator.service';
import { DatePipe } from '@angular/common';
import { AuthService } from '../services/auth.service';


@Component({
  selector: 'dashboard-cmp',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  resultSheetState : Boolean;
  advanceSheetState : Boolean;
  language : String;
  siteContent : any;
  calculatortype : string;
  calculatorunittype : string;
  IndustrialMode : Boolean;
  HouseholdMode : Boolean;
  calculatorunittypeDisable : Boolean;
  installationMethodList : any;
  wirecore : String;
  wirematirial : String;
  wiretype : String;
  units : any;
  calculatorUnit : String;
  unitdisplay : String;
  caldis : Boolean;
  calValue : String;
  voltageDrop : String;
  voltDis : Boolean;
  cableLength : String;
  installationMethod : String;
  calculatorunittypeDisplay : String;
  output : String;
  basicSheetState : Boolean;
  industrialMode : Boolean;
  appSetting : any;
  displayInstallMethod :Boolean;
  assumption : String;
  hpmode : Boolean;
  now: any;
  userId: string;

  constructor(
    private flashMessage: FlashMessagesService,
    private authService: AuthService,
    private router: Router,
    private validateService:ValidateService,
    private calculatorService : CalculatorService
  ) { }

  ngOnInit() {
    this.getLanguage();debugger;
    this.languageSelector();
    this.hpmode = false;
    this.voltDis = false;
    this.resultSheetState = false;
    this.advanceSheetState = false;
    this.IndustrialMode = false;
    this.HouseholdMode = false;
    this.basicSheetState =  true;
    this.getAppSetting();
    this.voltageDrop = "3"
    this.calculatortype = "I"
    this.calTypeSelected();

    this.authService.getProfile().subscribe(data =>{
      console.log(data);
      this.userId = data.content._id;
      console.log(this.userId);
    }, err => {
      alert("Failed to retrieve user details.");
    });    
  }

  getLanguage(){
    let lang = localStorage.getItem('language');
    console.log(lang)
    this.language = lang;
  }

  languageSelector(){
    console.log("language select")
      let lang = localStorage.getItem('language');
      if(lang == "S"){
        this.loadSinhalaVersion();
      }else if(lang =="T"){
        this.loadTamilVersion();
      }else{
        this.loadEnglishVersion();
      }
  }

  loadEnglishVersion(){

    const caltype =  [
      {value : "I", text : "Industrial"},
      {value : "H", text : "Household"}
    ]
    const unittypeH = [
      {value : "1", text : "Current in Amp"},
      {value : "2", text : "Power in HP"}
    ]
    const unittypeI = [
      {value : "1", text : "Current in Amp"},
      {value : "2", text : "Power in KVA"}
    ]
    const core = [
      {value : "1", text : "Single"},
      {value : "2", text : "Multi"}
    ]

    const matirial = [
      {value : "1", text : "Copper"},
      {value : "2", text : "Aluminium"}
    ]
    const wireType = [
      {value : "1", text : "Armoured"},
      {value : "2", text : "Non-Armoured"}
    ]
    const lang = {
        heading1 : "Basic Information",
        heading2 : "Advanced Information",
        heading3 : "Result Sheet",
        card1 : "Calculator Type",
        card2 : "Unit Type",
        card3 : "Unit",
        card4 : "Cable length",
        card5 : "Core",
        card6 : "Material",
        card7 : "Cable type",
        card8 : "Installation method",
        card9 : "Voltage Drop",
        card10 : "Assumptions",
        caltype : caltype,
        unittypeI: unittypeI,
        unittypeH: unittypeH,
        matirial : matirial,
        wireType :wireType,
        core : core,
        button2 : "Calculate",
        button1 : "Clear"
    }
    this.siteContent = lang;
  }

  loadSinhalaVersion(){
    const caltype =  [
      {value : "I", text : "කර්මාන්ත"},
      {value : "H", text : "ගෘහ"}
    ]
    const unittypeH = [
      {value : "1", text : "Current in Amp"},
      {value : "2", text : "Power in HP"}
    ]
    const unittypeI = [
      {value : "1", text : "Current in Amp"},
      {value : "2", text : "Power in KVA"}
    ]
    const core = [
      {value : "1", text : "තනි"},
      {value : "2", text : "බහු"}
    ]

    const matirial = [
      {value : "1", text : "තඹ"},
      {value : "2", text : "ඇලුමිනියම්"}
    ]
    const wireType = [
      {value : "1", text : "සන්නද්ධ"},
      {value : "2", text : "ආරක්ෂාව නැති"}
    ]
    const lang = {
        heading1 : "මූලික තොරතුරු",
        heading2 : "උසස් තොරතුරු",
        heading3 : "ප්රතිඵල ලේඛනය",
        card1 : "කැල්ක්යුලේටරය වර්ගය",
        card2 : "ඒකකය වර්ගය",
        card3 : "ඒකකය",
        card4 : "කේබල් දිග",
        card5 : "හරය",
        card6 : "අයිතමය",
        card7 : "කේබල් වර්ගය",
        card8 : "ස්ථාපනය කරන ක්රමය",
        card9 : "Voltage Drop",
        card10 : "Assumptions",
        caltype : caltype,
        unittypeI: unittypeI,
        unittypeH: unittypeH,
        matirial : matirial,
        wireType :wireType,
        core : core,
        button2 : "ගණනය",
        button1 : "නැවත සකසන්න "
    }
    this.siteContent = lang;
  }

  loadTamilVersion(){
    const caltype =  [
      {value : "I", text : "தொழிற்சாலை"},
      {value : "H", text : "வீட்டு"}
    ]
    const unittypeH = [
      {value : "1", text : "Current in Amp"},
      {value : "2", text : "Power in HP"}
    ]
    const unittypeI = [
      {value : "1", text : "Current in Amp"},
      {value : "2", text : "Power in KVA"}
    ]
    const core = [
      {value : "1", text : "ஒற்றை"},
      {value : "2", text : "மல்டி"}
    ]

    const matirial = [
      {value : "1", text : "காப்பர்"},
      {value : "2", text : "அலுமினியம்"}
    ]
    const wireType = [
      {value : "1", text : "கவச"},
      {value : "2", text : "பாதுகாப்பற்ற"}
    ]
    const lang = {
        heading1 : "அடிப்படை தகவல்",
        heading2 : "மேம்பட்ட தகவல்",
        heading3 : "முடிவு தாள்",
        card1 : "கால்குலேட்டர் வகை",
        card2 : "அலகு வகை",
        card3 : "அலகு",
        card4 : "கேபிள் நீளம்",
        card5 : "கோர்",
        card6 : "பொருள்",
        card7 : "கேபிள் வகை",
        card8 : "நிறுவல் முறை",
        card9 : "Voltage Drop",
        card10 : "Assumptions",
        caltype : caltype,
        unittypeI: unittypeI,
        unittypeH: unittypeH,
        matirial : matirial,
        wireType :wireType,
        core : core,
        button2 : "கணக்கிட",
        button1 : "தெளிவான"
    }
    this.siteContent = lang;
  }

  calTypeSelected(){
      if(this.calculatortype == "I" ){
        this.IndustrialSelect();
      }
      if (this.calculatortype == "H" ) {
          this.HouseholdSelect();
      }
  }

  wireTypeSelect(){
  let wireType = {
    type : this.wiretype,
    lang : this.language
  }
  
    this.calculatorService.getInstallationMethods(wireType).subscribe(
      (data) => {
        if(data[0].error == false){
          this.installationMethodList = data[2].content;
          this.displayInstallMethod = true;
        }else{
          this.flashMessage.show("Please check your internet connection", { cssClass: 'alert-danger', timeout: 5000 });
        }
     },
    (err)=>{
      this.flashMessage.show("Please check your internet connection", { cssClass: 'alert-danger', timeout: 5000 });
    });
}
selectInsMethod(){
  let insmethodList = this.installationMethodList;
  let insmethod = this.installationMethod;
  for(var i = 0; i < insmethodList.length; i++){
    let currentmethod = insmethodList[i];
    if(currentmethod._id == insmethod ){
      this.installationMethod = currentmethod.Key; 
    }
  }
  console.log(this.installationMethod);
}
  HouseholdSelect(){
    this.advanceSheetState = false;
    this.resultSheetState = false;
    this.HouseholdMode = true;
    this.IndustrialMode = false;
    this.voltDis = false;
    this.calculatorunittype = "1"
    this.industrialMode = false;
  }
  IndustrialSelect(){
    this.advanceSheetState = true;
    this.resultSheetState = false;
    this.HouseholdMode = false;
    this.IndustrialMode = true;
    this.voltDis = true;
    this.calculatorunittype = "1"
    this.industrialMode = true;
  }

  reloadLacation(){
    location.reload();
  }


  updateUnitValue(){
    this.hpmode = false;
    if (this.calculatorunittype == "1" && this.calculatortype == "H" ) {
       this.calculatorUnit = "Amp"
    }else if(this.calculatorunittype == "2" && this.calculatortype == "H" ){
       this.hpmode = true;
       this.calculatorUnit = "HP"
    }else if(this.calculatorunittype == "1" && this.calculatortype == "I" ){
       this.calculatorUnit = "Amp"
    }else if(this.calculatorunittype == "2" && this.calculatortype == "I" ){
      this.calculatorUnit = "KVA"
    }
    console.log(this.calculatorUnit)
  }

  calculate(){
    if(this.calculatortype == "I"){
      this.selectInsMethod();
    }
   const wire = {
      unitType : this.calculatorunittype,
      unit : this.calculatorUnit,
      calValue : this.calValue,
      voltageDrop : this.voltageDrop,
      cableLength : this.cableLength,
      wirecore : this.wirecore,
      wirematirial :  this.wirematirial,
      wiretype : this.wiretype,
      installationMethod : this.installationMethod,
      calculatorType: this.calculatortype
    }

    if (this.calculatortype == "I") {
      
      let validation = this.validateService.validateINDCalculator(wire);
      if(!validation.validation){
        this.flashMessage.show(validation.message, { cssClass: 'alert-danger', timeout: 5000 });
        return false;
      }
     if(!this.validateCalValue()){
        return false;
      }
      console.log(wire)
      this.calculatorService.executeCalculator(wire).subscribe(
        (data) => {
          this.genarateResult(data);
       },
      (err)=>{
        this.flashMessage.show("Please check your interner connection", { cssClass: 'alert-danger', timeout: 5000 });
      })
    }else{
      console.log("Home Select");
      const wireH = {
         unitType : this.calculatorunittype,
         unit : this.calculatorUnit,
         calValue : this.calValue,
         cableLength : this.cableLength,
         calculatorType: "H",
         wirecore : "1",
         wirematirial :  "1",
         wiretype : "2",
         installationMethod : "2",
       }
         console.log(wireH);

      let validation = this.validateService.validateHCalculator(wireH);
      if(!validation.validation){
        console.log("Err")
        this.flashMessage.show(validation.message, { cssClass: 'alert-danger', timeout: 5000 });
        return false;
      }
      
      this.calculatorService.executeCalculator(wireH).subscribe(
         (data) => {
           console.log("HOME CAL Recived")
           console.log(data);
           this.genarateResult(data);
        },
       (err)=>{
         this.flashMessage.show("Please check your interner connection", { cssClass: 'alert-danger', timeout: 5000 });
       })
 }
 }

 unitTypeSelect(){
  if(this.calculatorunittype == "1"){
    this.calculatorunittypeDisplay = this.siteContent.unittype[0].text
    this.unitdisplay = this.calculatorUnit;
    this.caldis = true;
  }else{
    this.calculatorunittypeDisplay = this.siteContent.unittype[1].text
    this.unitdisplay = this.calculatorUnit;
    this.caldis = true;
  }
}

  calculateCurrent(){
  let cal = this.calValue.toString();
  let val = parseInt(cal);
  if(this.calculatorUnit = "Amp"){
    return val;
  }else if(this.calculatorUnit = "KVA"){
    let sqr = (Math.sqrt(3));
    let ans = (val * 1000)/sqr*400
    return ans;
  }
}

validateCalValue(){
  let current = this.calculateCurrent();
  let installationMethod  =  this.installationMethod;
  let wirecore = this.wirecore;
  let typeofwire = this.wiretype;
  if(this.wirematirial == "1"){  //CU
    if(installationMethod == "KALANICABLE-INS-1"){
      if(current > 450 && wirecore =="2" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 600 && wirecore =="1" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else{
        return true;
      }
    }else if(installationMethod == "KALANICABLE-INS-2"){
      if(current > 600 && wirecore =="2" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 575 && wirecore =="2" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 800 && wirecore =="1" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 900 && wirecore =="1" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else{
        return true;
      }
    }else if(installationMethod == "KALANICABLE-INS-3"){
      if(current > 625 && wirecore =="2" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      } else if(current > 600 && wirecore =="2" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 900 && wirecore =="1" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 900 && wirecore =="1" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else{
        return true;
      }
    }else if(installationMethod == "KALANICABLE-INS-4"){
      if(current > 450 && wirecore =="2" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 700 && wirecore =="1" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else{
        return true;
      }
    }else{
      return true;
    }
  }else{ // AL
    if(installationMethod == "KALANICABLE-INS-1"){
      if(current > 350 && wirecore =="2" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 500 && wirecore =="1" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else{
        return true;
      }
    }else if(installationMethod == "KALANICABLE-INS-2"){
      if(current > 400 && wirecore =="2" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 400 && wirecore =="2" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 700 && wirecore =="1" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 750 && wirecore =="1" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else{
        return true;
      }
    }else if(installationMethod == "KALANICABLE-INS-3"){
      if(current > 450 && wirecore =="2" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 450 && wirecore =="2" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 750 && wirecore =="1" && typeofwire == "1" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 800 && wirecore =="1" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else{
        return true;
      }
    }else if(installationMethod == "KALANICABLE-INS-4"){
      if(current > 350 && wirecore =="2" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else if(current > 400 && wirecore =="1" && typeofwire == "2" ){
      this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
        return false;
      }else{
        return true;
      }
    }else{
      return true;
    }
  }

}

getAppSetting(){
  this.calculatorService.getSetting().subscribe(
    (data) => {
      console.log("data")
      console.log(data)
      this.appSetting = data;
   },
  (err)=>{

  })
}

getValueAppSetting(key){
  let setting = this.appSetting;
  for (let i = 0; i < setting.length; i++) {
    if(setting[i].key == key){
      return setting[i].value;
    }
  }
}

  genarateResult(result){
    console.log(result)
    if(result.error == true){
        this.flashMessage.show("Warning.! Unsupported range, Please contact " + this.getValueAppSetting("CONPERSON") + " "  + this.getValueAppSetting("CONNUMBER"), { cssClass: 'alert-danger', timeout: 10000 });
    }else{
      this.now = new Date();
      var value = new DatePipe("en-US");
      this.now = value.transform(this.now, "yyyy-MM-dd HH:mm:ss");

      this.resultSheetState = true;
      this.basicSheetState =  false;
      this.advanceSheetState =  false;

      let vdCable = result.vdCable;
      let calType = result.calculatorType;
      let cableType;
      let size = vdCable.size
      let wireinfo = result.wireinfo;
      if(size <= 16){
        cableType = "PVC";
      }else{
        cableType = "XLPE";
      }
      if(vdCable.type == true && calType == "H"){
          this.output = "Cable size " + vdCable.size + " mm2 " 
      }else{
        if(vdCable.type == true){
          if(vdCable.arm == true && vdCable.core == true){
            this.output = "1 x "+ vdCable.size +"mm2 Cu/ "+ cableType +" /AWA / PVC"
          }else if(vdCable.arm == false && vdCable.core == true){
            this.output = "1 x "+ vdCable.size +"mm2 Cu/ "+ cableType +" / PVC"
          }else if(vdCable.arm == true && vdCable.core == false){
            this.output = "4 x "+ vdCable.size +"mm2 Cu/ "+ cableType +" /SWA / PVC"
          }else if(vdCable.arm == false && vdCable.core == false){
            this.output = "4 x "+ vdCable.size +"mm2 Cu/ "+ cableType +" /PVC"
          } 
        }else{
          if(vdCable.arm == true && vdCable.core == true){
            this.output = "1 x "+ vdCable.size +"mm2 Al/ "+ cableType +" /AWA / PVC"
          }else if(vdCable.arm == false && vdCable.core == true){
            this.output = "1 x "+ vdCable.size +"mm2 Al/ "+ cableType +" / PVC"
          }else if(vdCable.arm == true && vdCable.core == false){
            this.output = "4 x "+ vdCable.size +"mm2 Al/ "+ cableType +" /SWA / PVC"
          }else if(vdCable.arm == false && vdCable.core == false){
            this.output = "4 x "+ vdCable.size +"mm2 Al/ "+ cableType +" /PVC"
          } 
        }
      }

    
      if(calType == "H"){
        this.assumption = "Assumptions for household calculations are as follows.\n Ambient temperature is 30 celsius Enclosed in Conduit method installation. "
      }else{
        this.assumption = "For Industrial calculations the assumptions are as follows,\n"
        +  " Ambient air temperature is 30 celsius "
        +  " Underground temperature is 25 celsius "
        +  " Depth of laying is 0.5m "
        +  " Soil thermal resistivity is 1.5Km/W "
        +  " One multi core cable or three or four Single core cables (for one circuit) ";
      }

      //Check if a voltage drop value exists (Household has no voltage drop value)
      var vd;
      if(!wireinfo.voltageDrop){
        vd = "";
      } else{
        vd = wireinfo.voltageDrop;
      }

      const obj ={
        'calculatorType' : wireinfo.calculatorType,
        'unit' : wireinfo.unit,
        'calValue' : wireinfo.calValue,
        'voltageDrop' : vd,
        'cableLength' : wireinfo.cableLength,
        'wirecore' : wireinfo.wirecore,
        'wirematirial' : wireinfo.wirematirial,
        'wiretype' : wireinfo.wiretype,
        'installationMethod' : wireinfo.installationMethod,
        'device_address' : wireinfo.address,
        'result' : this.output,
        'assumption' : this.assumption,
        'language' : this.language,
        'date' : this.now
      }

      this.calculatorService.saveResultRecord(this.userId,obj).subscribe((data) => {
          console.log("data");
          console.log(data);
          // this.getUserResults();
      }, (err)=>{
          // alert("There was an issue in saving your search result!");
          console.log(err);
      });
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts